import { Spacing } from '@persona-id/design-tokens';
import { XIcon } from '@persona-id/design-tokens/icons';
import { ComponentProps } from 'react';
import styled from 'styled-components';

import ConnectedInquiryRun from 'dashboard/components/ConnectedInquiryRun';
import { ModalContainer } from 'dashboard/layouts/ModalLayout';
import { Heading } from 'design-system/components/Text';
import { BASE } from 'design-system/variables/spacing';

const InquiryRunModalContainer = styled(ModalContainer)`
  position: relative;
  height: clamp(600px, 85vh, 1100px);
  width: clamp(1150px, 90vw, 1700px);
  padding: 0;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${BASE * 8}px;
  padding: ${Spacing[5]};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: auto;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  overflow: hidden;
`;

const CloseButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  cursor: pointer;
  margin-left: auto;
  background: none;
  border: 0;
`;

interface InquiryRunModalProps extends ComponentProps<typeof ConnectedInquiryRun> {
  handleClose: () => void;
}

const InquiryRunModal = ({
  currentEnvironment,
  inquiry,
  locale,
  handleClose,
}: InquiryRunModalProps) => (
  <InquiryRunModalContainer>
    <Header>
      <Heading size='sm'>Inquiry run</Heading>
      <CloseButton id='inquiry-run-modal__close-button' onClick={handleClose}>
        <XIcon size={24} />
      </CloseButton>
    </Header>
    <Container>
      <ConnectedInquiryRun
        currentEnvironment={currentEnvironment}
        inquiry={inquiry}
        locale={locale}
      />
    </Container>
  </InquiryRunModalContainer>
);

export default InquiryRunModal;
